export default {
    methods: {
        getSelected (list, nombre) {
            var selected = {};
            if (nombre) {
              for ( let key in list ){
                const element = list[key];
                if (element) {
                  if (element.nombre) {
                    if (element.nombre.trim() == nombre.trim() ){
                      selected = element;
                    }
                  }
                }
              }
            }
            return selected;
        },
        camelize(str) {
          return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
            if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
              return index == 0 ? match.toUpperCase() : match.toLowerCase();
          });
        }                     
    },
};


// WEBPACK FOOTER //
// ./src/mixins/helpers.js